// extracted by mini-css-extract-plugin
export var contentBody = "_b7-9";
export var headerImage = "_b7-2";
export var imageButton = "_b7-7";
export var imageButtonIcon = "_b7-8";
export var imageHeader = "_b7-4";
export var imageHeaderText = "_b7-5";
export var imageOverlay = "_b7-3";
export var imageTitle = "_b7-6";
export var imageWrapper = "_b7-1";
export var taskList = "_b7-a";
export var widget = "_b7-0";